import {extractRepoOrgScopes} from '@github-ui/blackbird-query-parsing/common'
import {parseString} from '@github-ui/blackbird-query-parsing/parsing'

/**
 * Matches `org:VALUE` and `repo:OWNER/NAME` in a raw search query against the orgs the
 * viewer has not completed SAML single sign-on for. Search silently drops every repo in
 * those orgs, so a query scoped to one returns no results with no explanation.
 *
 * Returns each org's canonical login rather than the casing the query used, so an org
 * named twice with different casing yields one entry.
 */
export function ssoOrgsInQuery(query: string, ssoOrgLogins: string[]): string[] {
  if (!query || ssoOrgLogins.length === 0) return []

  const canonicalLogins = new Map(ssoOrgLogins.map(login => [login.toLowerCase(), login]))
  const matched = new Set<string>()

  const addMatch = (value: string | undefined) => {
    const canonical = value && canonicalLogins.get(value.toLowerCase())
    if (canonical) matched.add(canonical)
  }

  for (const scope of extractRepoOrgScopes(parseString(query))) {
    for (const value of scope.value.split(',')) {
      if (scope.kind === 'org') {
        addMatch(value)
      } else if (scope.kind === 'repo') {
        addMatch(value.split('/', 1)[0])
      }
    }
  }

  return [...matched]
}
